module.exports = __webpack_public_path__ + "img/1.2555df80.jpg";